(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4474],{

/***/ 324474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListDescriptionSection": function() { return /* binding */ ListDescriptionSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CardFrameCollection_components_CarouselIndicator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(254505);
/* harmony import */ var src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(135400);
/* harmony import */ var _ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(939102);
/* harmony import */ var _ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _NewAnnouncementBar_Components_InfiniteAutoScroller__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(673861);
/* harmony import */ var _context_ListPresentationContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(101657);










function ListDescriptionSection(param) {
    var onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick;
    var handleInstaClick = // const updatedHtmlForMoveableText = `<div style="display: flex; align-items: center; gap: 28px;"> <div style="height: 10px; width: 10px; border-radius: 50%; background: #111C36; opacity: .3;"></div> <div style = "font-weight: 400;">${listPresentationConfig?.heading} </div></div>`
    function handleInstaClick() {
        window.open("https://instagram.com/".concat(instaHandle), "_blank");
    };
    var data = (0,_context_ListPresentationContext__WEBPACK_IMPORTED_MODULE_7__/* .useListPresentationContextData */ .ds)();
    var _state = data.state, isMobile = _state.isMobile, listPresentationConfig = _state.listPresentationConfig, contentTypeConditions = _state.contentTypeConditions;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, sectionColors = _generalValues.sectionColors, showArrow = _generalValues.showArrow, carouselConfigs = _generalValues.carouselConfigs, featuredReelConfigs = _generalValues.featuredReelConfigs, carouselIndicatorConfigs = _generalValues.carouselIndicatorConfigs, isMoveableHeading = _generalValues.isMoveableHeading, // containerHorizontalPadding,
    isLayoutCarousel = _generalValues.isLayoutCarousel, instaHandleProps = _generalValues.instaHandleProps;
    var ref = instaHandleProps || {}, _showInstaHandle = ref.showInstaHandle, showInstaHandle = _showInstaHandle === void 0 ? false : _showInstaHandle, _instaHandle = ref.instaHandle, instaHandle = _instaHandle === void 0 ? "" : _instaHandle, _instaHandlePosition = ref.instaHandlePosition, instaHandlePosition = _instaHandlePosition === void 0 ? "" : _instaHandlePosition;
    var isLogoSliderCarousel = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel" && contentTypeConditions.logoSlider;
    var isFocusedReelExpandOnMobile = featuredReelConfigs.expandFocusedReel;
    var alwaysShowInLeft = isMoveableHeading && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top";
    var displayLabelStyles = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getDisplayLabelStyles */ .KZ)(listPresentationConfig, alwaysShowInLeft);
    var ref1 = (0,_CardFrameCollection_components_CarouselIndicator__WEBPACK_IMPORTED_MODULE_4__.useGetChevronComponent)({
        type: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowShape,
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        isMobile: isMobile,
        scrollPercentage: carouselIndicatorConfigs.scrollPercentage,
        colorConfig: {
            arrowColor: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowColor,
            shapeColor: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.shapeColor
        }
    }), LeftArrow = ref1.LeftArrow, RightArrow = ref1.RightArrow;
    var headingText = (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__/* .getTitleWithoutTags */ .f)(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading);
    var descriptionText = (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__/* .getTitleWithoutTags */ .f)(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.description);
    var isEmptyText = !(headingText || descriptionText);
    var isTextCenter = listPresentationConfig.textAlign === "center";
    var showInstaUserName = function() {
        return instaHandle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: handleInstaClick,
            className: "tw-mt-[8px] hover:tw-underline tw-leading-[1.4] tw-cursor-pointer [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-text-[14px] tw-font-normal tw-text-[#111C36B2]",
            style: {
                textAlign: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left"
            },
            children: "@".concat(instaHandle)
        });
    };
    var renderMoveableHeadingContent = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-[28px] tw-mt-[26px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-h-[10px] tw-w-[10px] tw-rounded-[50%] tw-bg-newBlack tw-opacity-30"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit tw-w-max ".concat(isTextCenter ? "tw-text-center" : "", " ").concat((_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_8___default().group)),
                    style: {
                        color: sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text
                    },
                    dangerouslySetInnerHTML: {
                        __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading
                    }
                })
            ]
        });
    };
    var renderMoveableHeading = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_NewAnnouncementBar_Components_InfiniteAutoScroller__WEBPACK_IMPORTED_MODULE_6__/* .InfiniteAutoScroller */ .k, {
            gap: 28,
            scrollSpeedInSec: 4,
            totalItems: 4,
            wrapperClasses: "!tw-flex-none",
            customClasses: "!tw-m-0",
            maxWidth: isMoveableHeading && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top" && isLayoutCarousel && !isMobile ? "90%" : "100%",
            children: [
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent()
            ]
        });
    };
    return !isEmptyText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("tw-relative tw-mx-auto tw-flex tw-flex-col", !isEmptyText || showArrow ? isMobile ? !isLogoSliderCarousel ? isFocusedReelExpandOnMobile ? "tw-mb-[36px]" : "tw-mb-[24px]" : "" : isLogoSliderCarousel ? "tw-mb-[1px]" : "tw-mb-[36px]" : "", (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.descriptionPosition) === "top" ? "tw-flex-col-reverse" : ""),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, displayLabelStyles),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-w-[100%] tw-flex-col",
                style: displayLabelStyles,
                children: [
                    isMoveableHeading && renderMoveableHeading(),
                    !isMoveableHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit ".concat(isTextCenter ? "tw-text-center" : ""),
                        style: {
                            color: sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text
                        },
                        dangerouslySetInnerHTML: {
                            __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading
                        }
                    }),
                    !isMobile && showArrow && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-absolute tw-right-0 tw-top-[50%] tw-flex tw-translate-y-[calc(-50%_-_2px)] tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftArrow, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightArrow, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    justifyContent: showInstaHandle ? (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left" : ""
                },
                className: "tw-w-[100%] ".concat(showInstaHandle ? !isMobile ? "tw-flex tw-items-center" : "tw-flex tw-flex-col" : ""),
                children: [
                    descriptionText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-m-0 tw-mt-[8px] tw-leading-[1.4] [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-mr-[8px]",
                        style: {
                            color: "#808080",
                            textAlign: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left"
                        },
                        dangerouslySetInnerHTML: {
                            __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.description
                        }
                    }),
                    showInstaHandle && instaHandlePosition === "description" && showInstaUserName()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 135400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getTitleWithoutTags; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);

var getTitleWithoutTags = function(title) {
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) {
        return title;
    }
    var htmlString = title;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    var text = tempDiv.textContent || tempDiv.innerText;
    return text;
};


/***/ }),

/***/ 939102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListPresentation_carousel__lyRBR","group":"ListPresentation_group___ECsm","scrolling":"ListPresentation_scrolling__8grpZ"};

/***/ })

}]);